module.exports = __webpack_public_path__ + "img/20190916170819249.883af978.jpg";